export { ResultCard } from './ResultCard';
export type { ResultCardProps } from './ResultCard.types';
